<template>
  <v-layout row wrap>
    <v-flex d-flex xs12 align-center justify-center>
      <table class="sets-summary table-responsive">
        <tbody>
          <tr>
            <th>
              {{ match.setText }}
            </th>
            <th v-for="(set, i) in match.sets" :key="`set_h1_${i}`">
              {{ i + 1 }}
            </th>
          </tr>
          <tr v-if="match.type !== 'baseballBase'">
            <th>{{ match.localTeamAcronym }}</th>
            <template v-for="(row, i) in match.setsTableData.rowsL">
              <td :class="{ odd: i % 2, even: !(i % 2) }">
                {{ row.score }}
              </td>
            </template>
          </tr>
          <tr>
            <th>{{ match.visitorTeamAcronym }}</th>
            <template v-for="(row, i) in match.setsTableData.rowsV">
              <td :class="{ odd: i % 2, even: !(i % 2) }">
                {{ row.score }}
              </td>
            </template>
          </tr>
          <tr v-if="match.type === 'baseballBase'">
            <th>{{ match.localTeamAcronym }}</th>
            <template v-for="(row, i) in match.setsTableData.rowsL">
              <td :class="{ odd: i % 2, even: !(i % 2) }">
                {{ row.score }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </v-flex>
  </v-layout>
</template>

<script>
// const debug = require('debug')('OD::BasicStats')

export default {
  name: 'BasicStats',
  components: {},
  props: {
    match: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.sets-summary {
  th {
    padding: 0 5px;
    background-color: #ddd;
  }
  th.white {
    background-color: #fff;
  }
  td {
    background-color: #f8f8f8;
    text-align: center;
  }
  th.odd,
  td.odd {
    background-color: #f0f0f0;
  }
  th.even,
  td.even {
    background-color: #f8f8f8;
  }
  td.bold {
    font-weight: bold;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  border: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
}
</style>
